var path = 'app/scripts/modules/core/src/serverGroup/details/multipleServerGroup.component.html';
var html = "<h5>\n  <div class=\"server-group-name\" ng-class=\"$ctrl.serverGroup.disabled ? 'disabled' : ''\">\n    <cloud-provider-logo provider=\"$ctrl.serverGroup.provider\" height=\"'20px'\" width=\"'20px'\"></cloud-provider-logo>\n    {{$ctrl.serverGroup.name}}\n  </div>\n</h5>\n<div class=\"server-group-details\">\n  <account-tag account=\"$ctrl.serverGroup.account\"></account-tag>\n  {{$ctrl.serverGroup.region}}\n  <health-counts container=\"$ctrl.serverGroup.instanceCounts\"></health-counts>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/serverGroup/details/multipleServerGroup.component.html
// module id = 1084
// module chunks = 0